import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  getReferringProviders,
  createReferringProvider,
  updateReferringProvider,
  deleteReferringProvider,
} from "app/services/referringProvider/referringProviderService";
import { BASE_URL } from "static/constants";

export const referringProviderApi = createApi({
  reducerPath: "referringProviderApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["referringProviders"],
  endpoints: ({ query, mutation }) => ({
    getReferringProviders: query({
      queryFn: () => {
        return {
          data: getReferringProviders(),
        };
      },
      providesTags: ["referringProviders"],
    }),
    createReferringProvider: mutation({
      queryFn: (payload) => {
        return { data: createReferringProvider(payload) };
      },
      invalidatesTags: ["referringProviders"],
    }),
    updateReferringProvider: mutation({
      queryFn: ({ id, payload }) => {
        return { data: updateReferringProvider(id, payload) };
      },
      invalidatesTags: ["referringProviders"],
    }),
    deleteReferringProvider: mutation({
      queryFn: (id) => {
        return { data: deleteReferringProvider(id) };
      },
      invalidatesTags: ["referringProviders"],
    }),
  }),
});

export const {
  useGetReferringProvidersQuery,
  useCreateReferringProviderMutation,
  useUpdateReferringProviderMutation,
  useDeleteReferringProviderMutation,
} = referringProviderApi;
